import aa from 'search-insights';

const ALGOLIA_INSIGHTS_HOST = 'https://insights.algolia.io';
const ALGOLIA_EVENTS_ENDPOINT = '/1/events';

let didInit = false;

export const aaClient = aa;

export function initAlgoliaInsights(sessionStore) {
    if(didInit) return;

    aa('init', {
        appId: sessionStore.appId,
        apiKey: sessionStore.apiKey,
        userToken: sessionStore.userToken,
        authenticatedUserToken: sessionStore.authUserToken
    });

    didInit = true;
}

function shouldSeedSandbox(sessionStore) {
    return sessionStore.indexStag
        && sessionStore.indexStag !== sessionStore.index
        && sessionStore.appIdStag
        && sessionStore.apiKeyStag;
}

function sendSandboxInsight(sessionStore, eventType, params) {
    let seedSandbox = shouldSeedSandbox(sessionStore);

    const sandboxParams = {
        ...params,
        index: sessionStore.indexStag
    };

    if(!seedSandbox && sessionStore.isAvibe) {
        console.log("****** AVIBE Only -- Algolia event tracking code ******");
        console.log(eventType + ' => ' + JSON.stringify(sandboxParams));
    }

    if(!seedSandbox) return;

    fetch(ALGOLIA_INSIGHTS_HOST + ALGOLIA_EVENTS_ENDPOINT, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Algolia-Application-Id': sessionStore.appIdStag,
            'X-Algolia-API-Key': sessionStore.apiKeyStag
        },
        body: JSON.stringify({
            events: [sandboxParams]
        }),
        keepalive: true
    }).catch((err) => {
        if(sessionStore.isAvibe) {
            console.log('Sandbox Algolia event failed: ' + err);
        }
    });
}

export function sendAlgoliaEvent(sessionStore, eventType, params) {
    aa(eventType, params);
    sendSandboxInsight(sessionStore, eventType, params);
}
